import React from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./ui/tooltip";

/** Icon-only action button with a reliable tooltip (native title tips are unreliable). */
export function ActionIcon({ icon: Icon, label, onClick, testId, className = "", disabled }) {
  return (
    <TooltipProvider delayDuration={120}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            aria-label={label}
            className={`btn-ghost !p-2 ${className}`}
            data-testid={testId}
          >
            <Icon size={14} />
          </button>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          className="!rounded-none border text-xs font-medium"
          style={{ background: "var(--ink)", color: "#F7F7F6", borderColor: "var(--ink)" }}
        >
          {label}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default ActionIcon;
